"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseICalendarCreateEventBodyEntity = void 0;
const icalendar_create_event_body_entity_attendees_1 = require("./icalendar-create-event-body-entity-attendees");
const icalendar_create_event_body_entity_body_1 = require("./icalendar-create-event-body-entity-body");
const icalendar_create_event_body_entity_recurrence_1 = require("./icalendar-create-event-body-entity-recurrence");
const icalendar_create_event_body_entity_start_1 = require("./icalendar-create-event-body-entity-start");
const icalendar_event_lite_location_1 = require("./icalendar-event-lite-location");
function parseICalendarCreateEventBodyEntity(data) {
    if (data.body !== null && typeof data.body === 'object')
        data.body = (0, icalendar_create_event_body_entity_body_1.parseICalendarCreateEventBodyEntityBody)(data.body);
    if (data.start !== null && typeof data.start === 'object')
        data.start = (0, icalendar_create_event_body_entity_start_1.parseICalendarCreateEventBodyEntityStart)(data.start);
    if (data.end !== null && typeof data.end === 'object')
        data.end = (0, icalendar_create_event_body_entity_start_1.parseICalendarCreateEventBodyEntityStart)(data.end);
    if (data.location !== null && typeof data.location === 'object')
        data.location = (0, icalendar_event_lite_location_1.parseICalendarEventLiteLocation)(data.location);
    if (data.attendees !== null && typeof data.attendees === 'object')
        data.attendees = data.attendees.map((x) => (0, icalendar_create_event_body_entity_attendees_1.parseICalendarCreateEventBodyEntityAttendees)(x));
    if (data.recurrence !== null && typeof data.recurrence === 'object')
        data.recurrence = (0, icalendar_create_event_body_entity_recurrence_1.parseICalendarCreateEventBodyEntityRecurrence)(data.recurrence);
    return data;
}
exports.parseICalendarCreateEventBodyEntity = parseICalendarCreateEventBodyEntity;
